<template>
  <div></div>
  <div class="container">
    <h1 class="platform">
      Platform:
      <span
        :class="[
          'platform-active',
          { 'platform-inactive': platform !== 'apple' },
        ]"
        v-on:click="switchPlatform('apple')"
        >Apple</span
      >
      <span
        :class="[
          'platform-active',
          { 'platform-inactive': platform !== 'google' },
        ]"
        v-on:click="switchPlatform('google')"
        >Google</span
      >
      <span
        :class="[
          'platform-active',
          { 'platform-inactive': platform !== 'total' },
        ]"
        v-on:click="switchPlatform('total')"
        >All</span
      >
    </h1>
    <h2 class="analytics-group-title">Results</h2>
    <div class="installs-uninstalls">
      <h3>
        Installs:
        <span class="installs">{{
          platformAnaylitics?.installsVsUninstalls?.installs
        }}</span>
      </h3>
      <h3>
        Uninstalls:
        <span class="uninstalls">{{
          platformAnaylitics?.installsVsUninstalls?.uninstalls
        }}</span>
      </h3>
    </div>
    <div class="analytics-grid-2-cols">
      <AnalyticsCardOrganism
        v-for="result in platformAnaylitics?.results"
        :title="result.name"
        :key="result.name"
        icon="analyticsUsers"
        class="analytics-card"
      >
        <template #body>
          <table>
            <tr v-for="item in result?.data" :key="item.name">
              <td class="row-name">{{ item.name }}</td>
              <td class="value">{{ item.value }}</td>
            </tr>
          </table>
        </template>
      </AnalyticsCardOrganism>
    </div>
  </div>
  <div class="container">
    <h2 class="analytics-group-title">Indicators</h2>
    <div class="analytics-grid-2-cols">
      <AnalyticsCardOrganism
        v-for="indicator in platformAnaylitics?.indicators"
        :title="indicator.name"
        :key="indicator.name"
        icon="analyticsUsers"
        class="analytics-card"
      >
        <template #body>
          <table>
            <tr v-for="item in indicator?.data" :key="item.name">
              <td class="row-name">{{ item.name }}</td>
              <td class="value">{{ item.value }}</td>
            </tr>
          </table>
        </template>
      </AnalyticsCardOrganism>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue';
  import { useStore } from 'vuex';
  import AnalyticsCardOrganism from '../analytics-card/AnalyticsCardOrganism.vue';

  const platform = ref('apple');

  const store = useStore();
  const dashboardAnalytics = computed(
    () => store.getters['dashboardAnalytics/getDashboardAnaylitics'],
  );

  const platformAnaylitics = computed(() => {
    if (dashboardAnalytics.value) {
      return dashboardAnalytics.value[platform.value];
    }
    return null;
  });

  const switchPlatform = (newPlatform: string) => {
    if (newPlatform === platform.value) {
      return;
    }
    platform.value = newPlatform;
  };
</script>

<style scoped src="./style.css" />
